import { apiClient, apiClientPublic } from "services/api-client"

export const sendVerifyCode = async (email, companyId) => {
  return await apiClientPublic.post(`user/auth/send-verify-code`, {
    email,
    companyId
  })
}

export const userAuth = async (email, code, companyKey) => {
  return await apiClientPublic.post(`user/auth`, {
    code,
    email,
    companyKey
  })
}

// SPEC-AUTH-003 FR-1: body field is deliberately targetCompanyKey, never companyKey —
// see auth.controller.ts's postSwitchCompany comment for why renaming it would silently
// reactivate a stale companiesWithAccess check ahead of the real, fresh-DB authorization check.
export const switchCompany = async (targetCompanyKey) =>
  apiClient.post('/user/auth/switch-company', { targetCompanyKey })

// SPEC-AUTH-003 FR-7: fresh, identity-wide list of companies the caller can switch into.
export const getCompaniesWithAccess = async () =>
  apiClient.get('/user/auth/companies-with-access')